import { css } from '@emotion/core';
import {
  ChecklistMetricStatus,
  ExceptionChangeParams,
  MetricItemData,
} from '../../handoff-checklist-v2.types';
import { theme } from '@weave/theme-original';
import { MarkIcon, NakedButton, SpinningLoader, Text } from '@weave/design-system';
import { MetricAccordion } from '../metric-accordion/metric-accordion';

export interface MetricListItemProps {
  metric: MetricItemData;
  onOpenMetricDetail: () => void;
  defaultOpen?: boolean;
  forceAccordion?: boolean;
  readOnly?: boolean;
  showWhereToFix?: boolean;
  onExceptionChange?: (
    metricId: string,
    criteriaIndex: number,
    exception: string
  ) => void;
  onLocationExceptionChange?: (params: ExceptionChangeParams) => void;
}

export const MetricListItem = ({
  metric,
  onOpenMetricDetail,
  defaultOpen = false,
  forceAccordion = false,
  readOnly = false,
  showWhereToFix = true,
  onExceptionChange,
  onLocationExceptionChange,
}: MetricListItemProps) => {
  const isPassed = metric.status === ChecklistMetricStatus.PASSED;
  const isLoading = metric.isLoading;

  if (isLoading) {
    return (
      <div css={styles.item}>
        <SpinningLoader size="small" />
        <Text weight="medium" as="div">
          {metric.name}
        </Text>
      </div>
    );
  }

  if (isPassed && !forceAccordion) {
    return (
      <div css={styles.item}>
        <NakedButton onClick={onOpenMetricDetail}>
          <MarkIcon css={{ color: '#08873F' }} />
        </NakedButton>
        <Text weight="medium" as="div">
          {metric.name}
        </Text>
      </div>
    );
  }

  if ('locationResults' in metric) {
    return (
      <MetricAccordion
        metric={metric}
        defaultOpen={defaultOpen}
        readOnly={readOnly}
        showWhereToFix={showWhereToFix}
        onLocationExceptionChange={onLocationExceptionChange}
      />
    );
  }

  return (
    <MetricAccordion
      metric={metric}
      defaultOpen={defaultOpen}
      readOnly={readOnly}
      showWhereToFix={showWhereToFix}
      onExceptionChange={onExceptionChange}
    />
  );
};

const styles = {
  item: css`
    display: flex;
    align-items: center;
    padding: ${theme.spacing(1.5, 2)};
    gap: ${theme.spacing(2)};
  `,
};
